var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M9.1001 5.51969L0.340097 10.5773V0.462099L9.1001 5.51969Z","fill":"#FDE8E9"}})])}
var staticRenderFns = []

export { render, staticRenderFns }